import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { APP_LOAD_SPINNER_DEFAULT } from '../../../../../_CORE/APP/Templates/_UI/Screen/AppLoadSpinnerDefault';
import { ViewLayout } from '../../../../_UI/ViewLayout';
import { AdminPageHeader } from './AdminPageHeader';

/*
    Layout unico del administrador del portfolio.

    Importante: no inventa otro shell. Reutiliza ViewLayout, que es la
    estructura original del template para las vistas privadas:

        header  -> titulo/acciones
        toolbar -> reservado por el template
        content -> modulos de la pantalla

    De esta forma recuperamos exactamente el espaciado, margenes y jerarquia
    que ya tenia el proyecto base, pero con la identidad visual del portfolio.

    SPINNER DE SECCION
    ------------------
    Todas las rutas privadas que usan AdminViewLayout muestran el spinner
    existente del Core durante un minimo de 2 segundos al cambiar de ruta.
    No se crea otro loader ni otra animacion: se reutiliza
    APP_LOAD_SPINNER_DEFAULT para mantener la estetica del proyecto.

    Esto cubre de una sola vez:
    - Panel
    - Perfil
    - Proyectos
    - Proyectos en venta
    - Cotizaciones
    - Trayectoria
    - Blog
    - Redes
    - Correos y todas sus sub-secciones
*/
const SECTION_MIN_LOADING_MS = 2000;

export const AdminViewLayout = ({
    pageKey,
    eyebrow = 'Portfolio Studio',
    title,
    description,
    actions = null,
    children,
    isWide = false,
}) => {
    const { pathname } = useLocation();
    const [isSectionReady, setIsSectionReady] = useState(false);

    useEffect(() => {
        setIsSectionReady(false);

        const timer = window.setTimeout(() => {
            setIsSectionReady(true);
        }, SECTION_MIN_LOADING_MS);

        return () => window.clearTimeout(timer);
    }, [pathname]);

    const sectionSpinner = APP_LOAD_SPINNER_DEFAULT(
        1,
        56,
        1.2,
        false,
        'CARGANDO',
        'private',
    );

    return (
        <ViewLayout
            isWide={isWide}
            header={
                <AdminPageHeader
                    eyebrow={eyebrow}
                    title={title}
                    description={description}
                    actions={actions}
                />
            }
        >
            <div className="PBADMIN__section_stage" data-loading={!isSectionReady}>
                {!isSectionReady && (
                    <div
                        className="PBADMIN__section_loader"
                        role="status"
                        aria-live="polite"
                        aria-label={`Cargando ${title || 'seccion'}`}
                    >
                        {sectionSpinner}
                    </div>
                )}

                {/*
                    Los hijos se montan desde el primer render para que sus GET
                    empiecen inmediatamente. Mientras transcurren los 2 segundos
                    minimos quedan visualmente ocultos detras del spinner.
                */}
                <div
                    className={`PBADMIN__page PBADMIN__page--${pageKey || 'default'}`}
                    data-admin-page={pageKey || 'default'}
                    data-section-loading={!isSectionReady}
                    aria-hidden={!isSectionReady}
                >
                    {children}
                </div>
            </div>
        </ViewLayout>
    );
};
